module.exports = __webpack_public_path__ + "img/clean-house.16fabbc0.jpg";